import React from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}
